import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="site-footer">
            <div className="container">
                <div className="site-footer__grid">
                    <div className="site-footer__brand">
                        <Link to="/" className="brand brand--light" aria-label="Yay Fun, Inc. home">
                            <img src="/images/yayfun-mark.svg" alt="" width="32" height="32" className="brand__mark" />
                            <span className="brand__name">Yay Fun</span>
                        </Link>
                        <p>
                            A software product studio in Austin, Texas, and the maker of
                            PokeSwift and Social Bellow.
                        </p>
                    </div>

                    <div>
                        <h2 className="site-footer__heading">Products</h2>
                        <ul className="site-footer__list">
                            <li><a href="https://pokeswift.com" target="_blank" rel="noopener noreferrer">PokeSwift</a></li>
                            <li><a href="https://socialbellow.com" target="_blank" rel="noopener noreferrer">Social Bellow</a></li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="site-footer__heading">Company</h2>
                        <ul className="site-footer__list">
                            <li><Link to="/#what-we-do">What we do</Link></li>
                            <li><Link to="/about">About</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="site-footer__heading">Contact</h2>
                        <address className="site-footer__address">
                            Yay Fun, Inc.<br />
                            3616 Far West Blvd 117-414<br />
                            Austin, TX 78731<br />
                            <a href="tel:+15127295122">(512) 729-5122</a>
                        </address>
                    </div>
                </div>

                <div className="site-footer__bottom">
                    <span>© {new Date().getFullYear()} Yay Fun, Inc. All rights reserved.</span>
                    <span className="site-footer__legal">
                        <Link to="/privacy">Privacy</Link>
                        <Link to="/terms">Terms</Link>
                    </span>
                </div>
            </div>
        </footer>
    )
}

export default Footer
